import { addToast, Button } from '@octano/global-ui';
import { Col, Row } from 'reactstrap';
import { useActionKitImp } from '../../../../../components/ozmoit/common';
import { downloadFromBlob } from '../../../../../utils/blob';
import { getMassiveAdmissionCallTemplateAction } from '../actions';
import { useTexts } from '../hooks/useTexts';

export function CallFunctionalityButtons() {
  const texts = useTexts().callFunctionalityButtons;

  const { action: getTemplate, loading: downloading } = useActionKitImp(
    getMassiveAdmissionCallTemplateAction,
    {
      onSuccess: async (res) => {
        const fileName = `PlantillaConvocatoriaMasiva.xlsx`;

        const blob = new Blob([res.data], { type: 'vnd.ms-excel' });
        downloadFromBlob(blob, fileName);
      },
      onError: {
        unknown: () => {
          addToast({
            icon: 'error',
            text: texts.download.error,
            color: 'danger',
          });
        },
      },
    },
  );

  return (
    <>
      <Row className="my-2">
        <Col xs={12} sm={3}>
          <Button
            size="md"
            fullwidth
            outlined
            type="button"
            text={texts.individual}
          />
        </Col>

        <Col xs={12} sm={3}>
          <Button
            icon="download"
            size="md"
            fullwidth
            outlined
            type="button"
            text={texts.download.button}
            onClick={() => getTemplate()}
            loading={downloading}
          />
        </Col>

        <Col xs={12} sm={3}>
          <Button
            icon="upload"
            size="md"
            fullwidth
            outlined
            type="button"
            text={texts.massive}
          />
        </Col>

        <Col xs={12} sm={3}>
          <Button
            icon="mailing"
            size="md"
            fullwidth
            type="button"
            text={texts.notify}
          />
        </Col>
      </Row>
    </>
  );
}
